import { Injectable } from "@angular/core";
import { ApiService } from "./api-ws.service";
import { interval } from "rxjs";
import { count } from "console";

@Injectable()
export class PlaytestService {
    public countdown = 0;
    // private channel = new BroadcastChannel('auth_refresh');
    constructor(private restService: ApiService) {
        // this.channel.onmessage = (event) => {
        //     const { type, token } = event.data;
        //     switch (type) {
        //         case 'TRIGGER_TABS':
        //             this.countdown = 0;
        //             console.log('On trigger tabs')
        //             this.flood();
        //             break;

        //     }
        // };
    }
    public flood() {
        // interval(600).subscribe(() => {
        //     if (this.countdown >= 10) return;
        //     this.restService.getUsers$().subscribe();
        //     this.countdown++;
        // });
    }
    public sendTriggerTabs() {
        // this.flood();
        // this.channel.postMessage({ type: 'TRIGGER_TABS' });
    }
}